/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface CreateDiscountDto
 */
export interface CreateDiscountDto {
  _id?: string;
    /**
     * Display name for the discount
     * @type {string}
     * @memberof CreateDiscountDto
     */
    name?: string;
    /**
     * Optional description for internal use
     * @type {string}
     * @memberof CreateDiscountDto
     */
    description?: string;
    /**
     * ITEM_DISCOUNT: Shows on products automatically. COUPON_CODE: Requires code at checkout
     * @type {string}
     * @memberof CreateDiscountDto
     */
    type?: CreateDiscountDtoTypeEnum;
    /**
     * PERCENTAGE or FIXED_AMOUNT
     * @type {string}
     * @memberof CreateDiscountDto
     */
    valueType?: CreateDiscountDtoValueTypeEnum;
    /**
     * The discount value (percentage 1-100 or fixed dollar amount)
     * @type {number}
     * @memberof CreateDiscountDto
     */
    value?: number;
    /**
     * Maximum discount amount for percentage discounts (optional, mainly for COUPON_CODE)
     * @type {number}
     * @memberof CreateDiscountDto
     */
    cappedAt?: number;
    /**
     * Coupon code (required for COUPON_CODE type)
     * @type {string}
     * @memberof CreateDiscountDto
     */
    code?: string;
    /**
     * When the discount becomes active
     * @type {Date}
     * @memberof CreateDiscountDto
     */
    startsAt?: Date;
    /**
     * When the discount expires
     * @type {Date}
     * @memberof CreateDiscountDto
     */
    expiresAt?: Date;
    /**
     * Current lifecycle state
     * @type {string}
     * @memberof CreateDiscountDto
     */
    state?: CreateDiscountDtoStateEnum;
    /**
     * Quick toggle to enable/disable the discount
     * @type {boolean}
     * @memberof CreateDiscountDto
     */
    isActive?: boolean;
    /**
     * Products to apply discount to (all their variants will be discounted)
     * @type {Array<string>}
     * @memberof CreateDiscountDto
     */
    productsEligible?: Array<string>;
    /**
     * Specific variants to apply discount to
     * @type {Array<string>}
     * @memberof CreateDiscountDto
     */
    variantsEligible?: Array<string>;
    /**
     * Maximum total times this discount can be used (optional)
     * @type {number}
     * @memberof CreateDiscountDto
     */
    maxUses?: number;
    /**
     * Maximum times a single user can use this discount (optional)
     * @type {number}
     * @memberof CreateDiscountDto
     */
    maxUsesPerUser?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateDiscountDtoTypeEnum {
    ITEMDISCOUNT = 'ITEM_DISCOUNT',
    COUPONCODE = 'COUPON_CODE'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateDiscountDtoValueTypeEnum {
    PERCENTAGE = 'PERCENTAGE',
    FIXEDAMOUNT = 'FIXED_AMOUNT'
}
/**
    * @export
    * @enum {string}
    */
export enum CreateDiscountDtoStateEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    EXPIRED = 'EXPIRED',
    SCHEDULED = 'SCHEDULED'
}

